<template>
  <div v-if="loading" class="loading-spinner">
    <div class="spinner"></div>
  </div>

  <div v-else-if="api" class="space-y-6">
    <!-- Cabeçalho da API melhorado -->
    <div class="card">
      <div class="card-content">
        <div class="flex-between">
          <div class="flex-1">
            <div class="flex-start mb-3">
              <h1 class="title" style="margin-bottom: 0; margin-right: 1rem;">{{ api.name }}</h1>
              <span class="status-badge" :class="statusClass">
                {{ api.status }}
              </span>
            </div>
            <p class="text-gray-600 mb-4">{{ api.description }}</p>
            <div class="flex-start text-sm text-gray-500" style="gap: 2rem;">
              <span class="flex-start">
                <svg class="w-4 h-4 mr-2" style="width: 1rem; height: 1rem; margin-right: 0.5rem;" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4V12L16,16L12,4Z"/>
                </svg>
                Versão: {{ api.version }}
              </span>
              <span class="flex-start">
                <svg class="w-4 h-4 mr-2" style="width: 1rem; height: 1rem; margin-right: 0.5rem;" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z"/>
                </svg>
                Atualizado em: {{ formatDate(api.updatedAt) }}
              </span>
              <span v-if="api.baseUrl" class="flex-start">
                <svg class="w-4 h-4 mr-2" style="width: 1rem; height: 1rem; margin-right: 0.5rem;" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/>
                </svg>
                Base URL: {{ api.baseUrl }}
              </span>
            </div>
          </div>
          
          <!-- Ações melhoradas -->
          <div class="api-actions-container">
            <!-- Dropdown de Download -->
            <div class="download-dropdown">
              <button 
                @click="toggleDownloadMenu"
                class="btn-download"
                :class="{ 'btn-loading': downloadLoading }"
              >
                <svg v-if="!downloadLoading" class="btn-icon" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"/>
                </svg>
                <svg v-else class="btn-icon" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"/>
                </svg>
                Download
                <svg class="btn-icon" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M7,10L12,15L17,10H7Z"/>
                </svg>
              </button>
              
              <div v-if="showDownloadMenu" class="download-menu">
                <button @click="downloadSwagger('json')" class="download-menu-item">
                  <svg fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                  </svg>
                  <div>
                    <div class="font-medium">Swagger JSON</div>
                    <div class="text-xs text-gray-500">Formato padrão do OpenAPI</div>
                  </div>
                </button>
                
                <button @click="downloadSwagger('yaml')" class="download-menu-item">
                  <svg fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                  </svg>
                  <div>
                    <div class="font-medium">Swagger YAML</div>
                    <div class="text-xs text-gray-500">Formato legível por humanos</div>
                  </div>
                </button>
                
                <button @click="downloadPostmanCollection" class="download-menu-item">
                  <svg fill="currentColor" viewBox="0 0 24 24">
                    <path d="M13.527.099C6.955-.744.942 3.9.099 10.473c-.843 6.572 3.8 12.584 10.373 13.428 6.573.843 12.587-3.801 13.428-10.374C24.744 6.955 20.101.943 13.527.099zm2.471 7.485a.855.855 0 0 0-.593.25l-4.453 4.453-.307-.307-.643-.643c4.389-4.376 5.18-4.418 5.996-3.753zm-4.863 4.861l4.44-4.44a.62.62 0 1 1 .847.903l-4.699 4.125-.588-.588zm.33.694l-1.1.238a.06.06 0 0 1-.067-.032.06.06 0 0 1 .01-.073l.645-.645.512.512zm-2.803-.459l1.172-1.172.879.878-1.979.426a.074.074 0 0 1-.085-.039.072.072 0 0 1 .013-.093zm-3.646 6.058a.076.076 0 0 1-.069-.083.077.077 0 0 1 .022-.058l2.493-2.493.537.537-2.983 2.097zm1.287-2.76l2.68-2.68.537.537-3.217 2.143zm1.098-8.73l-.857-.857 1.857-1.857c.192-.192.507-.192.699 0l.857.857-2.556 1.857z"/>
                  </svg>
                  <div>
                    <div class="font-medium">Postman Collection</div>
                    <div class="text-xs text-gray-500">Para testes no Postman</div>
                  </div>
                </button>
                
                <button @click="downloadInsomnia" class="download-menu-item">
                  <svg fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zm5.568 16.568C16.152 18.484 14.176 19.5 12 19.5s-4.152-1.016-5.568-2.932c-.328-.444-.696-1.044-.696-1.568 0-.524.368-1.124.696-1.568C7.848 11.516 9.824 10.5 12 10.5s4.152 1.016 5.568 2.932c.328.444.696 1.044.696 1.568 0 .524-.368 1.124-.696 1.568z"/>
                  </svg>
                  <div>
                    <div class="font-medium">Insomnia Workspace</div>
                    <div class="text-xs text-gray-500">Para testes no Insomnia</div>
                  </div>
                </button>
              </div>
            </div>

            <!-- Botão de Testar API -->
            <button 
              @click="openTestModal"
              class="btn-test"
              :class="{ 'btn-loading': testLoading }"
            >
              <svg v-if="!testLoading" class="btn-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8,5.14V19.14L19,12.14L8,5.14Z"/>
              </svg>
              <svg v-else class="btn-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"/>
              </svg>
              Testar API
            </button>

            <!-- Botão de documentação -->
            <button @click="openDocumentation" class="btn-outline">
              <svg class="btn-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"/>
              </svg>
              Documentação
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Resto do conteúdo... -->
    
    <!-- Modal de Teste da API -->
    <div v-if="showTestModal" class="modal-overlay" @click.self="closeTestModal">
      <div class="modal-content test-api-modal">
        <div class="modal-header">
          <h3 class="modal-title">Testar API - {{ api.name }}</h3>
          <button @click="closeTestModal" class="close-button">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div class="modal-body">
          <!-- Construtor de Requisição -->
          <div class="test-section">
            <h4 class="test-section-title">
              <svg class="w-5 h-5" style="width: 1.25rem; height: 1.25rem;" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14.06 9.02l.92.92L9.06 15.96l-3.75 1.85 1.85-3.75 5.9-5.04zM17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"/>
              </svg>
              Configurar Requisição
            </h4>
            
            <div class="test-request-builder">
              <div class="form-group">
                <label class="form-label">Endpoint</label>
                <div class="flex-row gap-4">
                  <select v-model="testRequest.method" class="select-field" style="max-width: 120px;">
                    <option value="GET">GET</option>
                    <option value="POST">POST</option>
                    <option value="PUT">PUT</option>
                    <option value="DELETE">DELETE</option>
                    <option value="PATCH">PATCH</option>
                  </select>
                  <input 
                    v-model="testRequest.url"
                    type="text" 
                    class="input-field"
                    :placeholder="`${api.baseUrl}/exemplo`"
                  >
                </div>
              </div>

              <div class="form-group">
                <label class="form-label">Headers</label>
                <div class="space-y-2">
                  <div v-for="(header, index) in testRequest.headers" :key="index" class="flex-row gap-4">
                    <input 
                      v-model="header.key"
                      type="text" 
                      class="input-field"
                      placeholder="Nome do header"
                    >
                    <input 
                      v-model="header.value"
                      type="text" 
                      class="input-field"
                      placeholder="Valor do header"
                    >
                    <button @click="removeHeader(index)" class="btn-outline" style="padding: 0.75rem;">
                      <svg class="w-4 h-4" style="width: 1rem; height: 1rem;" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"/>
                      </svg>
                    </button>
                  </div>
                  <button @click="addHeader" class="btn-outline">
                    <svg class="btn-icon" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"/>
                    </svg>
                    Adicionar Header
                  </button>
                </div>
              </div>

              <div v-if="['POST', 'PUT', 'PATCH'].includes(testRequest.method)" class="form-group">
                <label class="form-label">Body (JSON)</label>
                <textarea 
                  v-model="testRequest.body"
                  class="input-field"
                  rows="8"
                  placeholder='{\n  "exemplo": "valor"\n}'
                ></textarea>
              </div>

              <div class="flex-row gap-4">
                <button 
                  @click="sendTestRequest"
                  class="btn-test"
                  :disabled="testRequestLoading"
                >
                  <svg v-if="!testRequestLoading" class="btn-icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8,5.14V19.14L19,12.14L8,5.14Z"/>
                  </svg>
                  <svg v-else class="btn-icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"/>
                  </svg>
                  {{ testRequestLoading ? 'Enviando...' : 'Enviar Requisição' }}
                </button>
                
                <button @click="clearTestRequest" class="btn-outline">
                  <svg class="btn-icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"/>
                  </svg>
                  Limpar
                </button>
              </div>
            </div>
          </div>

          <!-- Visualizador de Resposta -->
          <div v-if="testResponse" class="test-section">
            <h4 class="test-section-title">
              <svg class="w-5 h-5" style="width: 1.25rem; height: 1.25rem;" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14,12L10,8V11H2V13H10V16M20,5C21.11,5 22,5.89 22,7V17C22,18.11 21.11,19 20,19H4C2.89,19 2,18.11 2,17V15H4V17H20V7H4V9H2V7C2,5.89 2.89,5 4,5H20Z"/>
              </svg>
              Resposta
            </h4>
            
            <div class="test-response-viewer">
              <div class="response-status">
                <span class="font-medium">Status:</span>
                <span 
                  class="status-badge"
                  :class="testResponse.status >= 200 && testResponse.status < 300 ? 'status-badge-success' : 'status-badge-error'"
                >
                  {{ testResponse.status }} {{ testResponse.statusText }}
                </span>
                <span class="text-sm text-gray-500">• {{ testResponse.duration }}ms</span>
              </div>
              
              <div class="response-body">
                <div class="response-code">
                  {{ formatResponse(testResponse.data) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
import CodeSnippet from '@/components/api/CodeSnippet.vue'
import { getApiById } from '@/services/api'

const route = useRoute()
const router = useRouter()

const api = ref(null)
const loading = ref(false)
const activeTab = ref('endpoints')
const showCodeModal = ref(false)
const selectedEndpoint = ref(null)

// Estados dos botões de ação
const downloadLoading = ref(false)
const testLoading = ref(false)
const showDownloadMenu = ref(false)

// Estados do teste de API
const showTestModal = ref(false)
const testRequestLoading = ref(false)
const testRequest = ref({
  method: 'GET',
  url: '',
  headers: [
    { key: 'Authorization', value: 'Bearer YOUR_TOKEN' },
    { key: 'Content-Type', value: 'application/json' }
  ],
  body: ''
})
const testResponse = ref(null)

const tabs = [
  { id: 'endpoints', label: 'Endpoints' },
  { id: 'documentation', label: 'Documentação' },
  { id: 'examples', label: 'Exemplos' },
  { id: 'schemas', label: 'Esquemas' }
]

const statusClass = computed(() => {
  switch (api.value?.status?.toLowerCase()) {
    case 'active':
      return 'status-active'
    case 'deprecated':
      return 'status-deprecated'
    case 'inactive':
      return 'status-inactive'
    default:
      return ''
  }
})

const formatDate = (date) => {
  return new Date(date).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const loadApi = async () => {
  loading.value = true
  try {
    api.value = await getApiById(route.params.id)
    if (api.value?.baseUrl) {
      testRequest.value.url = api.value.baseUrl + '/example'
    }
  } catch (error) {
    console.error('Erro ao carregar API:', error)
    api.value = null
  } finally {
    loading.value = false
  }
}

// Funções de download
const toggleDownloadMenu = () => {
  showDownloadMenu.value = !showDownloadMenu.value
}

const downloadSwagger = async (format) => {
  downloadLoading.value = true
  showDownloadMenu.value = false
  
  try {
    // Simular download
    await new Promise(resolve => setTimeout(resolve, 1000))
    
    const content = format === 'json' 
      ? JSON.stringify({
          openapi: "3.0.0",
          info: {
            title: api.value.name,
            version: api.value.version,
            description: api.value.description
          },
          servers: [{ url: api.value.baseUrl }],
          paths: {}
        }, null, 2)
      : `openapi: 3.0.0\ninfo:\n  title: ${api.value.name}\n  version: ${api.value.version}\n  description: ${api.value.description}`
    
    const blob = new Blob([content], { 
      type: format === 'json' ? 'application/json' : 'text/yaml' 
    })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `${api.value.name.toLowerCase().replace(/\s+/g, '-')}.${format}`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
    
    console.log(`Download do Swagger ${format.toUpperCase()} iniciado`)
  } catch (error) {
    console.error('Erro no download:', error)
    alert('Erro ao fazer download do arquivo')
  } finally {
    downloadLoading.value = false
  }
}

const downloadPostmanCollection = async () => {
  downloadLoading.value = true
  showDownloadMenu.value = false
  
  try {
    await new Promise(resolve => setTimeout(resolve, 1000))
    
    const collection = {
      info: {
        name: api.value.name,
        description: api.value.description,
        schema: "https://schema.getpostman.com/json/collection/v2.1.0/collection.json"
      },
      item: api.value.endpoints?.map(endpoint => ({
        name: endpoint.description || `${endpoint.method} ${endpoint.path}`,
        request: {
          method: endpoint.method,
          header: [],
          url: {
            raw: `${api.value.baseUrl}${endpoint.path}`,
            host: [api.value.baseUrl],
            path: endpoint.path.split('/').filter(Boolean)
          }
        }
      })) || []
    }
    
    const blob = new Blob([JSON.stringify(collection, null, 2)], { type: 'application/json' })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `${api.value.name.toLowerCase().replace(/\s+/g, '-')}-postman.json`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
    
    console.log('Download da Postman Collection iniciado')
  } catch (error) {
    console.error('Erro no download:', error)
    alert('Erro ao fazer download da collection')
  } finally {
    downloadLoading.value = false
  }
}

const downloadInsomnia = async () => {
  downloadLoading.value = true
  showDownloadMenu.value = false
  
  try {
    await new Promise(resolve => setTimeout(resolve, 1000))
    
    const workspace = {
      _type: "export",
      __export_format: 4,
      resources: [{
        _id: "wrk_" + Date.now(),
        _type: "workspace",
        name: api.value.name,
        description: api.value.description
      }]
    }
    
    const blob = new Blob([JSON.stringify(workspace, null, 2)], { type: 'application/json' })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `${api.value.name.toLowerCase().replace(/\s+/g, '-')}-insomnia.json`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
    
    console.log('Download do Insomnia Workspace iniciado')
  } catch (error) {
    console.error('Erro no download:', error)
    alert('Erro ao fazer download do workspace')
  } finally {
    downloadLoading.value = false
  }
}

// Funções de teste de API
const openTestModal = () => {
  showTestModal.value = true
  testResponse.value = null
}

const closeTestModal = () => {
  showTestModal.value = false
  clearTestRequest()
}

const addHeader = () => {
  testRequest.value.headers.push({ key: '', value: '' })
}

const removeHeader = (index) => {
  testRequest.value.headers.splice(index, 1)
}

const clearTestRequest = () => {
  testRequest.value = {
    method: 'GET',
    url: api.value?.baseUrl ? `${api.value.baseUrl}/example` : '',
    headers: [
      { key: 'Authorization', value: 'Bearer YOUR_TOKEN' },
      { key: 'Content-Type', value: 'application/json' }
    ],
    body: ''
  }
  testResponse.value = null
}

const sendTestRequest = async () => {
  testRequestLoading.value = true
  
  try {
    const startTime = Date.now()
    
    // Simular requisição real
    await new Promise(resolve => setTimeout(resolve, Math.random() * 2000 + 500))
    
    const endTime = Date.now()
    const duration = endTime - startTime
    
    // Simular resposta baseada no método
    const isSuccess = Math.random() > 0.3
    const status = isSuccess ? (testRequest.value.method === 'POST' ? 201 : 200) : 400
    
    let mockData
    if (isSuccess) {
      mockData = testRequest.value.method === 'GET' 
        ? { 
            data: [
              { id: 1, name: "Exemplo 1", status: "active" },
              { id: 2, name: "Exemplo 2", status: "inactive" }
            ],
            total: 2,
            page: 1
          }
        : {
            id: Math.floor(Math.random() * 1000),
            message: "Operação realizada com sucesso",
            timestamp: new Date().toISOString()
          }
    } else {
      mockData = {
        error: "Bad Request",
        message: "Parâmetros inválidos na requisição",
        code: "INVALID_PARAMS"
      }
    }
    
    testResponse.value = {
      status: status,
      statusText: isSuccess ? (testRequest.value.method === 'POST' ? 'Created' : 'OK') : 'Bad Request',
      data: mockData,
      duration: duration
    }
    
  } catch (error) {
    testResponse.value = {
      status: 500,
      statusText: 'Internal Server Error',
      data: { error: 'Erro na requisição', message: error.message },
      duration: 0
    }
  } finally {
    testRequestLoading.value = false
  }
}

const formatResponse = (data) => {
  try {
    return JSON.stringify(data, null, 2)
  } catch (error) {
    return String(data)
  }
}

const openDocumentation = () => {
  // Abrir documentação em nova aba
  window.open(`${window.location.origin}/docs/${api.value.id}`, '_blank')
}

const generateCodeForEndpoint = (endpoint) => {
  selectedEndpoint.value = endpoint
  showCodeModal.value = true
}

const closeCodeModal = () => {
  showCodeModal.value = false
  selectedEndpoint.value = null
}

// Fechar dropdown ao clicar fora
onMounted(() => {
  loadApi()
  
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.download-dropdown')) {
      showDownloadMenu.value = false
    }
  })
})
</script>